import { MapTileFormats } from "../../enums/maps/mapTileFormats.enum";
import { URLUtilities } from "../url.utilities";

export class MapTileUrlValidator {

  private static readonly validators: Record<MapTileFormats, (url: string) => boolean> = {
    [MapTileFormats.XYZ]: (url) => {
      const u = url.toLowerCase();
      const isValidUrl = URLUtilities.isValidUrl(u);
      if(!isValidUrl) {
        return false;
      }

      return u.includes('{x}') && u.includes('{y}') && u.includes('{z}') && !u.includes('{-z}');
    },

    [MapTileFormats.TMS]: (url) => {
      // TMS is commonly denoted with {-z} in templates
      const u = url.toLowerCase();
      const isValidUrl = URLUtilities.isValidUrl(u);
      if(!isValidUrl) {
        return false;
      }

      return u.includes('{x}') && u.includes('{y}') && u.includes('{-z}');
    },

    [MapTileFormats.WMTS]: (url) => {
      // Expect TileMatrix={z}, TileCol={x}, TileRow={y} in any order, any casing
      const u = url.toLowerCase();
      const isValidUrl = URLUtilities.isValidUrl(u);
      if(!isValidUrl) {
        return false;
      }

      return (
        u.includes('tilematrix={z}') &&
        u.includes('tilecol={x}') &&
        u.includes('tilerow={y}')
      );
    },

    [MapTileFormats.Quadkey]: (url) => {
      // Support common patterns:
      // - {quadkey}
      // - {q}
      // - a{quadkey} (Bing-style)
      // - quadkey={quadkey}
      const u = url.toLowerCase();
      const isValidUrl = URLUtilities.isValidUrl(u);
      if(!isValidUrl) {
        return false;
      }

      return (
        u.includes('{quadkey}') ||
        u.includes('{q}') ||
        u.includes('a{quadkey}') ||
        u.includes('quadkey={quadkey}') ||
        u.includes('key={quadkey}') // some providers use ...key={quadkey}
      );
    },
  };

  public static validate(url: string, format: MapTileFormats): boolean {
    if (!url) return false;

    const validator = this.validators[format];
    return validator(url);
  }

  public static detectScheme(url: string): MapTileFormats | null {
    if (!url) return null;

    // Check WMTS first (it won’t collide with XYZ/TMS)
    if (this.validate(url, MapTileFormats.WMTS)) return MapTileFormats.WMTS;

    // Distinguish TMS vs XYZ using presence of {-z}
    if (this.validate(url, MapTileFormats.TMS)) return MapTileFormats.TMS;

    // Quadkey templates don’t use {x}/{y}/{z} placeholders
    if (this.validate(url, MapTileFormats.Quadkey)) return MapTileFormats.Quadkey;

    if (this.validate(url, MapTileFormats.XYZ)) return MapTileFormats.XYZ;

    return null;
  }
}
